// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialBar_wrapper__elCqN","socialItem":"SocialBar_socialItem__9JM9K","bounceIn":"SocialBar_bounceIn__STMoO","_footer":"SocialBar__footer__ZbfVx"};